import { Input, Select } from 'antd';
import TextTypography from 'src/app/components/shared/Typography/Text';

const { Option } = Select;

interface IProps {
    value: number | null;
    onChange: (val: number) => void;
    clasNames?: string;
    isLabel?: boolean;
}

const QuantitySelect = ({ value, onChange, clasNames, isLabel = true }: IProps) => {
    return (
        <div className="w-full">
            {isLabel ? (
                <label>
                    <TextTypography fontSize={14}>Quantity</TextTypography>
                </label>
            ) : null}{' '}
            <Input
                type="number"
                placeholder='Select Quantity'
                value={value??''}
                onChange={e => {
                  const value=e.target.value
                  onChange(Number(value));
                }}
                min={0}
                className={`h-[36px] w-full ${clasNames}`}
            />
        </div>
    );
};

export default QuantitySelect;
